import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class CountryInfoTextService {
  public readonly readMore$ = new BehaviorSubject<string>('Read more...');

  public toggleReadMore(
    event: MouseEvent | TouchEvent,
    fullyHidden: boolean,
    originalHeight: string = '',
  ): void {
    let extraInfoTextCN: ChildNode = (event.target as HTMLElement)
      .previousSibling;

    while (extraInfoTextCN.nodeName.includes('comment')) {
      extraInfoTextCN = extraInfoTextCN.previousSibling;
    }

    const extraInfoText: HTMLElement = extraInfoTextCN as HTMLElement;

    if (this.readMore$.value === 'Read more...') {
      extraInfoText.style.maxHeight = extraInfoText.scrollHeight + 'px';
      this.readMore$.next('Read less...');
    } else {
      extraInfoText.style.maxHeight = fullyHidden ? '0px' : originalHeight;
      window.scrollTo({ top: extraInfoText.offsetHeight });
      this.readMore$.next('Read more...');
    }
  }
}
